import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from 'antd';
import UIComponent from './uiComponent';
import { resovleContent } from './utils';
function UIInlineGridComponent(props) {
    return (_jsx(Flex, { gap: "middle", align: "center", style: { ...props.styling }, children: props.children }));
}
export default class UiInlineGrid extends UIComponent {
    style;
    constructor(s) {
        super(s);
        this.style = this.getProperty('style', '');
        resovleContent(this, s);
    }
    getComponent() {
        const props = {
            styling: this.style,
            children: this.children.map((c) => c.getComponent()),
        };
        return _jsx(UIInlineGridComponent, { ...props });
    }
}
//# sourceMappingURL=uiInlineGrid.js.map